export default {
  // Navbar
  features: "المميزات",
  solutions: "الحلول",
  testimonials: "الشهادات",
  pricing: "الأسعار",
  getStarted: "البدء",
  signIn: "تسجيل الدخول",
  signUp: "إنشاء حساب",
  darkMode: "الوضع الداكن",
  lightMode: "الوضع الفاتح",

  // Hero
  newVersion: "الإصدار الجديد 2.0 متاح الآن",
  heroTitle: "أدر مهامك بـ",
  heroSubtitle: "وضوح تام",
  heroDescription:
    "Brooklyn Task يمكّن الفرق من تنظيم الأولويات وتتبع العمل بشكل أسرع بكثير. توقف عن الغرق في الفوضى وابدأ في تحقيق النتائج.",
  startForFree: "ابدأ مجاناً",
  watchDemo: "شاهد العرض التوضيحي",
  trustedBy: "موثوق به من قبل فرق مبتكرة في",

  // Problems
  problemsTitle: "لماذا العمل فوضوي جداً؟",
  problemsSubtitle:
    "أنت توظف أشخاصاً رائعين، لكن العملية معقدة. النتيجة؟ مواعيد نهائية مائلة وإرهاق وارتباك.",
  problem1Title: "جزر التواصل",
  problem1Desc:
    'التحديثات متناثرة عبر البريد الإلكتروني وSlack وجداول البيانات. لا أحد يعرف أين يبحث عن النسخة "الأحدث".',
  problem2Title: "مواعيد نهائية فائتة",
  problem2Desc:
    "بدون رؤية واضحة، تنزلق المهام الحرجة من خلال الشقوق. تتأخر المشاريع ويصبح العملاء غير راضين.",
  problem3Title: "صفر رؤية",
  problem3Desc:
    'يقضي المديرون ساعات في محاولة معرفة "من يفعل ماذا" بدلاً من إدارة الاستراتيجية فعلياً.',

  // Solutions
  solution1Badge: "إدارة المهام",
  solution1Title: "المهام الروتينية والمرة الواحدة",
  solution1Desc:
    'تمييز بين العمل التشغيلي المتكرر ومعالم المشروع المحددة. Brooklyn Task ينظم "المهام الروتينية" بشكل منفصل عن "المهام لمرة واحدة" للحصول على أقصى وضوح.',
  solution1Feature1: "سير عمل مهام روتينية مخصصة",
  solution1Feature2: "معالم مشروع لمرة واحدة",
  solution1Feature3: "تصفية متقدمة حسب القسم",

  solution2Badge: "الفريق والأهداف",
  solution2Title: "محاذاة الفرق مع أهداف الشركة.",
  solution2Desc:
    "لا تكتفي بتتبع المهام—تتبع التأثير. اربط العمل الفردي مباشرة بأهداف الشركة عالية المستوى ومؤشرات الأداء الرئيسية للأقسام.",
  solution2Feature1: "تتبع الأهداف المرئي",
  solution2Feature2: "تقارير الأداء على مستوى القسم",
  solution2Feature3: "اتجاهات التقدم التلقائية",

  // Features
  featuresTitle: "كل ما تحتاجه للإطلاق بشكل أسرع",
  featuresSubtitle: "ميزات قوية ملفوفة في واجهة بسيطة وبديهية.",
  feature1Title: "المهام الروتينية",
  feature1Desc: "تبسيط العمليات اليومية المتكررة.",
  feature2Title: "تتبع الأهداف",
  feature2Desc: "ربط المهام بأهداف الشركة.",
  feature3Title: "الأقسام",
  feature3Desc: "تنظيم القوى العاملة حسب الوحدات المحددة.",
  feature4Title: "القوى العاملة",
  feature4Desc: "إدارة الاتفاقيات وبيانات الموظفين.",
  feature5Title: "الأتمتة",
  feature5Desc: "تشغيل الإجراءات عند تحديثات المهام.",
  feature6Title: "التقارير والرؤى",
  feature6Desc: "مخططات بصرية لاتجاهات الأداء.",
  feature7Title: "متعدد اللغات",
  feature7Desc: "دعم كامل للإنجليزية والعربية.",
  feature8Title: "التكاملات",
  feature8Desc: "يتصل بتطبيقاتك المفضلة.",

  // How It Works
  howItWorksTitle: "ابدأ في 3 خطوات",
  howItWorksSubtitle: "لا حاجة لبطاقة ائتمانية. جاهز للعمل في دقائق.",
  step1Title: "إنشاء مساحة عمل",
  step1Desc: "سجّل وادعُ أعضاء فريقك. نظّم حسب القسم أو المشروع.",
  step2Title: "استيراد أو إنشاء",
  step2Desc: "استورد المهام من Trello/Asana أو ابدأ من جديد باستخدام قوالبنا.",
  step3Title: "ابدأ العمل",
  step3Desc: "كلف المهام وتتبع التقدم واحتفل بالإنجازات مع الفريق.",

  // Testimonials
  testimonialsTitle: "محبوب من قبل أكثر من 10,000 فريق",
  testimonial1Text:
    "Brooklyn Task غيّر تماماً طريقة عمل فريق الهندسة لدينا. نطلق الآن بسرعة مضاعفة.",
  testimonial1Name: "سارة جنكينز",
  testimonial1Role: "مديرة التكنولوجيا في TechFlow",
  testimonial2Text:
    "أفضل واجهة مستخدم رأيتها في مدير مهام. من الممتع استخدامها بالفعل، وهو أمر نادر في برامج المؤسسات.",
  testimonial2Name: "مايكل تشين",
  testimonial2Role: "مدير المنتج",
  testimonial3Text:
    "أخيراً، أداة منطقية للفرق الإبداعية والتقنية على حد سواء. موصى به بشدة.",
  testimonial3Name: "جيسيكا ألفاريز",
  testimonial3Role: "مديرة التصميم",

  // Pricing
  pricingTitle: "أسعار بسيطة وشفافة",
  pricingSubtitle: "اختر الخطة المثالية لفريقك",
  choosePlan: "اختر الخطة",
  tryForFree: "جرب مجاناً",
  perMonth: "/شهر",
  noPlansAvailable: "لا توجد خطط متاحة حالياً",

  // CTA
  ctaTitle: "هل أنت مستعد لاستعادة السيطرة؟",
  ctaDescription:
    "انضم إلى آلاف الشركات التي تستخدم Brooklyn Task لتسليم المشاريع في الوقت المحدد، في كل مرة.",
  getStartedForFree: "ابدأ مجاناً",
  scheduleDemo: "جدولة عرض توضيحي",
  ctaFooter: "لا حاجة لبطاقة ائتمانية • تجربة مجانية لمدة 14 يوماً",

  // Footer
  footerDescription:
    "مساحة العمل الشاملة لمهامك وملاحظاتك ومشاريعك. بسيط ومرن وقوي.",
  footerProduct: "المنتج",
  footerCompany: "الشركة",
  footerLegal: "قانوني",
  integrations: "التكاملات",
  changelog: "سجل التغييرات",
  aboutUs: "من نحن",
  careers: "الوظائف",
  blog: "المدونة",
  contact: "اتصل بنا",
  privacyPolicy: "سياسة الخصوصية",
  termsOfService: "شروط الخدمة",
  security: "الأمان",
  footerCopyright: "© 2026 بروكلين . جميع الحقوق محفوظة.",
};
